module.exports = __webpack_public_path__ + "img/Creative studio Icon - charcoal.a2a10564.svg";